import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
import { WORKFLOW_ACTIONS_ACTION } from "../constant";

export const fetchWorkflowActionsData = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_START
    });
    return requestMethod(apiServices.fetchWorkflowActionsData())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_FAILURE
        });
      });
  };
};

export const createWorkflowAction = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_START
    });
    return requestMethod(apiServices.createWorkflowAction(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_FAILURE
        });
      });
  };
};

export const deleteWorkflowAction = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_START
    });
    return requestMethod(apiServices.deleteWorkflowAction(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_FAILURE
        });
      });
  };
};

export const fetchWorkflowStateCategoryData = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_START
    });
    return requestMethod(apiServices.fetchWorkflowStateCategoryData())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_FAILURE
        });
      });
  };
};

export const createWorkflowStateCategory = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_START
    });
    return requestMethod(apiServices.createWorkflowStateCategory(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_FAILURE
        });
      });
  };
};

export const deleteWorkflowStateCategory = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_START
    });
    return requestMethod(apiServices.deleteWorkflowStateCategory(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_FAILURE
        });
      });
  };
};

export const fetchWorkflowStateData = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_START
    });
    return requestMethod(apiServices.fetchWorkflowStateData())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FAILURE
        });
      });
  };
};

export const fetchWorkflowStateDataForCentral = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_START
    });
    return requestMethod(apiServices.fetchWorkflowStateDataForCentral())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type:
            WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_FAILURE
        });
      });
  };
};

export const createWorkflowState = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_START
    });
    return requestMethod(apiServices.createWorkflowState(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_FAILURE
        });
      });
  };
};

export const deleteWorkflowState = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_START
    });
    return requestMethod(apiServices.deleteWorkflowState(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_FAILURE
        });
      });
  };
};

export const fetchWorkflows = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_START
    });
    return requestMethod(apiServices.fetchWorkflowData())
      .then(resp => {
        const {
          data: { data }
        } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_FAILURE
        });
      });
  };
};

export const createWorkflow = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_START
    });
    return requestMethod(apiServices.createWorkflow(data))
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_FAILURE
        });
      });
  };
};

export const getWorkflowtype = (data, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_START
    });
    return requestMethod(apiServices._workflowtype())
      .then(resp => {
        const { data } = resp;
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_SUCCESS,
          payload: data
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_FAILURE
        });
      });
  };
};
